import "@/App.css";
import { Suspense, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { Toaster } from "@/components/ui/sonner";
import { PwaUpdatePrompt } from "@/components/PwaUpdatePrompt";
import Login from "@/pages/Login";
import { PageLoading } from "@/components/PageLoading";
import { lazyNamed } from "@/lib/lazyNamed";

const AdminDashboard = lazyNamed(() => import("@/pages/AdminDashboard"));
const PromoterDashboard = lazyNamed(() => import("@/pages/PromoterDashboard"));
const StaffDashboard = lazyNamed(() => import("@/pages/StaffDashboard"));
const OffDecisionPage = lazyNamed(() => import("@/pages/OffDecisionPage"));
const RestDayDecisionPage = lazyNamed(() => import("@/pages/RestDayDecisionPage"));
const ReactivationDecisionPage = lazyNamed(() => import("@/pages/ReactivationDecisionPage"));
const OffActCancelDecisionPage = lazyNamed(() => import("@/pages/OffActCancelDecisionPage"));

function Gate() {
  const { user } = useAuth();
  useEffect(() => {
    document.documentElement.classList.toggle("ui-v2", !!user);
  }, [user]);
  if (user === undefined) return <PageLoading full />;
  if (!user) return <Login />;
  if (user.role === "admin") return <AdminDashboard />;
  if (user.role === "audioprotesista" || user.role === "receptionist") return <StaffDashboard />;
  return <PromoterDashboard />;
}

function App() {
  return (
    <div className="App min-h-screen">
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter>
            <Suspense fallback={<PageLoading full />}>
            <Routes>
              <Route path="/off-decision/:token" element={<OffDecisionPage />} />
              <Route path="/restday-decision/:token" element={<RestDayDecisionPage />} />
              <Route path="/reactivation-decision/:token" element={<ReactivationDecisionPage />} />
              <Route path="/offact-cancel-decision/:token" element={<OffActCancelDecisionPage />} />
              <Route path="*" element={<Gate />} />
            </Routes>
            </Suspense>
          </BrowserRouter>
          <Toaster position="top-right" />
          <PwaUpdatePrompt />
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
